import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `EmpresaCentro/actualizarEmpresa`, method: 'POST', body: values, token: token})
}